<template>
  <div class="accodion_box accodion_total">
    <div class="accodion_box_tit">
      <a href="#target_total" data-toggle="collapse" aria-expanded="true">
        <div class="panel-title">
          <span class="text-uppercase accordion-header-text">결제금액</span>
          <span class="pull-right icon-arr"></span>
        </div>
      </a>
    </div>
    <div
      id="target_total"
      class="accodion_box_cont00 collapse in"
      role="tabpanel"
      aria-expanded="true"
    >
      <div class="accodion_box_cont">
        <div class="box_cart-info">
          <div class="box_row-group">
            <div class="box_row-info">
              <p class="txt_total-title">주문금액</p>
              <p class="txt_total-info">{{ totalPaymentInfo.orderPrice }}원</p>
            </div>
            <div class="box_row-info">
              <p class="txt_total-title">배송비</p>
              <p class="txt_total-info">{{ totalPaymentInfo.deliveryFee }}원</p>
            </div>
            <div class="box_row-info">
              <p class="txt_total-title">포장비</p>
              <p class="txt_total-info">{{ totalPaymentInfo.packagingFee }}원</p>
            </div>
            <div class="box_row-info">
              <p class="txt_total-title">할인정보</p>
              <p class="txt_total-info">{{ totalPaymentInfo.totalDiscount }}원</p>
            </div>
          </div>
          <div class="box_row-info box_price">
            <p class="txt_total-title">총 결제금액</p>
            <p class="txt_total-info">{{ totalPaymentInfo.totalPrice }}원</p>
          </div>
          <div class="box_row-info box_total">
            <p class="txt_total-title">총 PV/BV</p>
            <p class="txt_total-info">
              <span class="text_price-pv"
                >{{ totalPaymentInfo.totalPv }} /</span
              >
              <span class="text_price-bv">{{ totalPaymentInfo.totalBv }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSummary",
  props: {
    totalPaymentInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          orderPrice: 0,
          deliveryFee: 0,
          packagingFee: 0,
          totalDiscount: 0,
          totalPrice: 0,
          totalPv: 0,
          totalBv: 0,
        };
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/composition/payment/PaymentSummary.vue